<ng-container class="page-container" *ngIf="error_msg === '' && meeting_show">
  <div *ngIf="safeURL !== ''" class="iframe-container">
    <iframe class="iframes" *ngIf="safeURL !== ''" #jioMeetFrame allowfullscreen frameborder="0" width="100%"
      [src]="safeURL" allow="camera; microphone;display-capture"></iframe>
  </div>
</ng-container>